import { styled } from '@mui/material';
import { Button, Icon, Stack, Text } from 'shell/components';

const SUMMARY_ICONS_BY_STRUCTURE = Object.freeze({
    rubric: 'task',
    system: 'subtask',
    custom: 'messageRectangular',
});

const getSummaryIcon = (structure) => SUMMARY_ICONS_BY_STRUCTURE[structure] || 'task';

const PreferenceSummary = ({
    actionLabel,
    isDefault,
    items,
    defaultLabel = 'Default',
    onAction,
    structure,
    summaryTitle,
    title,
}) => (
    <SummaryCard>
        <Text variant='p2' weight='medium'>
            {title}
        </Text>
        <SummaryPanel>
            {(summaryTitle || isDefault) && (
                <Stack alignItems='center' direction='row' spacing={2}>
                    {summaryTitle && (
                        <>
                            <Icon kind={getSummaryIcon(structure)} sx={{ fontSize: 24 }} />
                            <Text variant='p2' weight='semibold'>
                                {summaryTitle}
                            </Text>
                        </>
                    )}
                    {isDefault && (
                        <StatusTag>
                            <Text
                                sx={{ color: (theme) => theme.palette.ensightful.primary[700] }}
                                variant='p3'
                                weight='medium'
                            >
                                {defaultLabel}
                            </Text>
                        </StatusTag>
                    )}
                </Stack>
            )}
            <Stack spacing={4} sx={{ py: 0, px: 4, width: '100%' }}>
                {items
                    ?.filter(({ value }) => value != null && value !== '')
                    .map(({ id, label, value }) => (
                        <Stack key={id} spacing={2}>
                            {label && (
                                <Text color='light' variant='p2'>
                                    {label}
                                </Text>
                            )}
                            <Text maxLines={3} variant='p2' weight='medium'>
                                {value}
                            </Text>
                        </Stack>
                    ))}
            </Stack>
        </SummaryPanel>
        <Stack alignItems='flex-end' sx={{ width: '100%' }}>
            <Button size='medium' variant='primary' onClick={onAction}>
                {actionLabel}
            </Button>
        </Stack>
    </SummaryCard>
);

const SummaryCard = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.ensightful.shades[0],
    border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    borderRadius: 20,
    gap: theme.spacing(3),
    padding: theme.spacing(4),
}));

const SummaryPanel = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.ensightful.neutral[50],
    border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    borderRadius: 16,
    gap: theme.spacing(3),
    padding: theme.spacing(4),
    width: '100%',
}));

const StatusTag = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.ensightful.primary[50],
    borderRadius: 40,
    padding: theme.spacing(1, 2),
}));

export default PreferenceSummary;
